import { AxiosMULEEX, AxiosBookings } from "../apiConfig";
import { appendQueryParams } from "../../utilities/urlUtils";

export const globalApiFunctions = {
  $_getAllStates() {
    let url = "/state";
    return AxiosMULEEX.get(url);
  },
  $_getAllStatesAndCities() {
    let url = "/utilities/states-and-cities";
    return AxiosMULEEX.get(url);
  },
  $_getCities(stateName) {
    let url = `/cities/${stateName}`;
    return AxiosMULEEX.get(url);
  },
   $_getBanners(params) {
    let url = `/booking/active-promo${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
};
